export const DB_NAME = 'editor-starter-assets';
export const DB_VERSION = 1;
export const DB_OBJECT_STORE_NAME = 'assets';
